import Favorites from './Favorites'

export default Favorites



// WEBPACK FOOTER //
// ./src/features/Personal/containers/Favorites/index.js